import { route } from 'quasar/wrappers'
import { onBeforeRouteUpdate, createMemoryHistory, createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import routes from './routes'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory)

  const router = createRouter({
    routes,
    history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE)
  })
  router.afterEach((to, from) => {
    const _hsq = window._hsq = window._hsq || []
    if (_hsq) {
      _hsq.push(['setPath', to.path])
      _hsq.push(['trackPageView'])
    }
  })

  router.options.scrollBehavior = async (to, from, savedPosition) => {
    let goTo

    if (to.hash) {
      goTo = {
        el: to.hash,
        behavior: 'smooth',
        top: 64
      }
    } else if (savedPosition) {
      goTo = savedPosition
    } else {
      goTo = { top: 0, behavior: 'smooth' }
    }

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(goTo)
      }, 100)
    })
  }

  return router
})
